import ShareUpdate from '@/views/ShareUpdate/index.vue'

const ShareFlightRouter = {
  path: '/share-flight',
  name: 'ShareFlight',
  component: ShareUpdate,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default ShareFlightRouter
